import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import solutions from '../components/solutions.vue'
import Products from '../components/Products'
import about from '../components/about.vue'
import financialplanningtips from '../components/financialplanningtips.vue'
import legalassistance from '../components/legalassistance.vue'
import business from '../components/business.vue'
import improve from '../components/improve.vue'
import intelligence from '../components/intelligence.vue'
import implement from '../components/implement.vue'
import management from '../components/management.vue'
import implementation from '../components/implementation.vue'
import professionals from '../components/professionals.vue'
import loan from '../components/loan.vue'
import teams from '../components/teams.vue'
import analytics from '../components/analytics.vue'
import transform from '../components/transform.vue'
import organization from '../components/organization.vue'
import utilizing from '../components/utilizing.vue'
import artificial from '../components/artificial.vue'
import growth from '../components/growth.vue'
import Conditions from '../components/Conditions.vue'
import privacy from '../components/privacy.vue'
import adapting from '../components/adapting.vue'
import transformative from '../components/transformative.vue'
import navigating from '../components/navigating.vue'
import evolution from '../components/evolution.vue'
import choosing from '../components/choosing.vue'
import trends from '../components/trends.vue'
import companypages from '../components/companypages.vue'
import companypagestwo from '../components/companypagestwo.vue'
import companypagestree from '../components/companypagestree.vue'
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
    
        {
            path: '/Products',
            name: 'Products',
            component: Products
        },
        {
            path: '/solutions',
            name: 'solutions',
            component: solutions
        },
        {
            path: '/about',
            name: 'about',
            component: about
        },
        {
            path: '/financialplanningtips',
            name: 'financialplanningtips',
            component: financialplanningtips
        },
        {
            path: '/legalassistance',
            name: 'legalassistance',
            component: legalassistance
        },
        {
            path: '/business',
            name: 'business',
            component: business
        },
        {
            path: '/business',
            name: 'business',
            component: business
        },
        {
            path: '/improve',
            name: 'improve',
            component: improve
        },
        {
            path: '/intelligence',
            name: 'intelligence',
            component: intelligence
        },
        {
            path: '/implement',
            name: 'implement',
            component: implement
        },
        {
            path: '/management',
            name: 'management',
            component: management
        },
        {
            path: '/implementation',
            name: 'implementation',
            component: implementation
        },
        {
            path: '/professionals',
            name: 'professionals',
            component: professionals
        },
        {
            path: '/loan',
            name: 'loan',
            component: loan
        },
        {
            path: '/teams',
            name: 'teams',
            component: teams
        },
        {
            path: '/analytics',
            name: 'analytics',
            component: analytics
        },
        {
            path: '/transform',
            name: 'transform',
            component: transform
        },
        {
            path: '/organization',
            name: 'organization',
            component: organization
        },
        {
            path: '/utilizing',
            name: 'utilizing',
            component: utilizing
        },
        {
            path: '/artificial',
            name: 'artificial',
            component: artificial
        },
        {
            path: '/growth',
            name: 'growth',
            component: growth
        },
        {
            path: '/terms',
            name: 'terms',
            component: Conditions
        },
        {
            path: '/privacy-policy/',
            name: 'privacy-policy/',
            component: privacy
        },
        {
            path: '/adapting',
            name: 'adapting',
            component: adapting
        },
        {
            path: '/transformative',
            name: 'transformative',
            component: transformative
        },
        {
            path: '/navigating',
            name: 'navigating',
            component: navigating
        },
        {
            path: '/evolution',
            name: 'evolution',
            component: evolution
        },
        {
            path: '/choosing',
            name: 'choosing',
            component: choosing
        },
        {
            path: '/trends',
            name: 'trends',
            component: trends
        },
        {
            path: '/companypages',
            name: 'companypages',
            component: companypages
        },
        {
            path: '/companypagestwo',
            name: 'companypagestwo',
            component: companypagestwo
        },
        {
            path: '/companypagestree',
            name: 'companypagestree',
            component: companypagestree
        },
    ]
})
